<template>
  <div v-if="computedShow" class="transaction-results-modal-component">
    <v-dialog
      v-model="computedShow"
      :persistent="true"
      width="700"
      content-class="transaction-results-modal-component"
    >
      <span class="modal-title">Операция выполнена</span>
      <font-awesome-icon icon="check-circle" />
      <v-btn @click="close" class="button-primary">
        Вернуться в раздел касса
      </v-btn>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'TransactionResultModal',
    props: {
      show: Boolean,
    },
    computed: {
      computedShow: {
        get () {
          return this.show
        },
        set (value) {
          this.$emit('update:show', value)
        },
      },
    },
    methods: {
      close () {
        this.$emit('close')
        this.computedShow = false
      },
    },
  }
</script>

<style lang="less" scoped>
  .transaction-results-modal-component {
  }
</style>
